import { render, staticRenderFns } from "./GroupsAll.vue?vue&type=template&id=22aa9dee&scoped=true&"
import script from "./GroupsAll.vue?vue&type=script&lang=ts&"
export * from "./GroupsAll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aa9dee",
  null
  
)

export default component.exports